<template>
  <div class="form-group">
    <div :class="hasIcon(icon)">
      <span v-if="iconDir === 'left'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
      <select
        multiple
        :disabled="isDisabled"
        :value="modelValue"
        :required="isRequired"
        class="form-control"
        v-model="selected"
        @click="onSelect($event)"
      >
        <option disabled value="">
          {{ selectedOption }}
        </option>
        <option v-for="item in modelValue" :key="item.id" :value="item.id">
          {{ item.title }}
        </option>
      </select>
      <span v-if="iconDir === 'right'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedOption: {
      type: String,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: true,
    },
    modelValue: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    iconDir: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.placeholder,
      selectedSubcourses: [],
    };
  },
  /* computed: {
    selectedFruits: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  }, */
  methods: {
    getClasses: (size, success, error) => {
      let sizeValue, isValidValue;

      sizeValue = size ? `form-control-${size}` : null;

      if (error) {
        isValidValue = "is-invalid";
      } else if (success) {
        isValidValue = "is-valid";
      } else {
        isValidValue = "";
      }

      return `${sizeValue} ${isValidValue}`;
    },
    getIcon: (icon) => (icon ? icon : null),
    hasIcon: (icon) => (icon ? "input-group" : null),
    onSelect(event) {
      this.selectedSubcourses = this.selectedSubcourses.concat(
        event.target.value
      );
      this.$emit("select1", Array.from(this.selectedSubcourses));
    },
  },
};
</script>
<style scoped>
.custom-select-container {
  margin: 20px;
}

.custom-select {
  width: 100%;
  height: 150px;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  color: #333;
}

.custom-select option {
  padding: 10px;
}

/* Stilizovanje selektovanih opcija */
.custom-select option:checked {
  background-color: #5cb85c;
  color: white;
}

/* Stilizovanje skrol trake */
.custom-select::-webkit-scrollbar {
  width: 12px;
}

.custom-select::-webkit-scrollbar-thumb {
  background-color: #5cb85c;
  border-radius: 6px;
}

.custom-select::-webkit-scrollbar-track {
  background-color: #f8f8f8;
}
</style>
